import { FunctionComponent } from 'react'
import { Button, Table } from 'react-bootstrap'
import Icon from 'components/ui/icon'

import CardSection from 'components/ui/cardSection'
import EmptyState from 'components/ui/emptyState'
import PersonCell from 'components/ui/personCell'
import { HospitalAdmin } from '../types'

type HospitalAdminsSectionProps = {
  admins: HospitalAdmin[]
  onAdd: () => void
  onRemove: (id: number) => void
}

const HospitalAdminsSection: FunctionComponent<HospitalAdminsSectionProps> = ({
  admins,
  onAdd,
  onRemove,
}) => (
  <CardSection
    className="mt-4"
    title="Admins"
    description="Funcionários que adicionam médicos e controlam o acesso aos repasses."
    actions={
      <Button size="sm" variant="secondary" onClick={onAdd}>
        <Icon name="plus" size={16} />
        Adicionar
      </Button>
    }
  >
    {admins.length === 0 ? (
      <EmptyState
        icon={<Icon name="users" size={20} />}
        title="Nenhum admin cadastrado"
      />
    ) : (
      <div className="table-wrap">
        <Table hover>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Email</th>
              <th className="actions-col">
                <span className="visually-hidden">Ações</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {admins.map((admin) => (
              <tr key={admin.id}>
                <td>
                  <PersonCell name={admin.name} />
                </td>
                <td className="muted">{admin.email}</td>
                <td className="actions-col">
                  <div className="row-actions">
                    <button
                      type="button"
                      className="row-action is-danger"
                      onClick={() => onRemove(admin.id)}
                    >
                      <Icon name="trash" size={14} />
                      Remover
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    )}
  </CardSection>
)

export default HospitalAdminsSection
